import {
  MEMBERSHIP_MONTHLY,
  MEMBERSHIP_ANNUAL,
  COACHING_SESSION,
  COACHING_SESSION_3_PACK,
  COACHING_SESSION_5_PACK,
  COACHING_SESSION_20_PERCENT_OFF,
} from '../../../../lib/constants/sku';

// upgrades: Replaces the current item in cart (up-sell)
// addOns: Items to add to cart (cross-sell)
export const productRecommendationBySku = {
  [MEMBERSHIP_MONTHLY]: {
    upgrades: [MEMBERSHIP_ANNUAL],
    addOns: [COACHING_SESSION_20_PERCENT_OFF],
  },
  [MEMBERSHIP_ANNUAL]: {
    addOns: [COACHING_SESSION_20_PERCENT_OFF],
  },
  [COACHING_SESSION]: {
    addOns: [MEMBERSHIP_MONTHLY, MEMBERSHIP_ANNUAL],
  },
  [COACHING_SESSION_3_PACK]: {
    addOns: [MEMBERSHIP_MONTHLY, MEMBERSHIP_ANNUAL],
  },
  [COACHING_SESSION_5_PACK]: {
    addOns: [MEMBERSHIP_MONTHLY, MEMBERSHIP_ANNUAL],
  },
};

export const addOnCards = {
  [COACHING_SESSION_20_PERCENT_OFF]: {
    title: 'Add a coaching session for 20% off',
    description: 'Book a 1-hour session with industry experts for mock interviews, negotiation, and personalized career advice.',
    linkText: 'Explore coaches',
    linkHref: '/coaching?category=mock_interviews',
  },
  [MEMBERSHIP_ANNUAL]: {
    title: 'Unlock Exponent membership',
    description: 'Get access to all courses, video answers, peer mock interviews, private community, AI features, job referrals and more.',
    priceSecondaryText: '/yr',
  },
};

export const upgradeCards = {
  [MEMBERSHIP_ANNUAL]: {
    title: 'Upgrade to annual membership',
    description: '12 months of interview prep for the price of 2. Get expert courses, peer/AI practice, mock interview examples, and more.',
    priceSecondaryText: '/yr',
  },
};
